import './meddeli1/style';
import FormStructure from './meddeli1/form_structure';

export default FormStructure;